import { action } from 'mobx';
import * as React from 'react';
import {
  PageProps,
  PageToolEvents,
} from '../../../../constants';
import { PageComponent } from '../../../../utils';
import { BreakMonthForecastTemplate } from './BreakMonthForecast.template';
import { Today } from '../../../../utils/time';
import { InfinityRetrieve } from '../../../../models';
import { BreakMonthForecastModel } from './BreakMonthForecast.model';
import { GridLayout } from '../../../../components';
import { ConfirmWarning } from '../../../../utils/confirm';

interface BreakMonthForecastState {
  // 조회조건
  year: string;

  // 리스트
  breakMonthList: Array<BreakMonthForecastModel>,

  // 합계
  // 고장
  cnt01_tot: string;
  cnt02_tot: string;
  cnt03_tot: string;
  cnt04_tot: string;
  cnt05_tot: string;
  cnt06_tot: string;
  cnt07_tot: string;
  cnt08_tot: string;
  cnt09_tot: string;
  cnt10_tot: string;
  cnt11_tot: string;
  cnt12_tot: string;

  // 예측정확도
  acc01_tot: string;
  acc02_tot: string;
  acc03_tot: string;
  acc04_tot: string;
  acc05_tot: string;
  acc06_tot: string;
  acc07_tot: string;
  acc08_tot: string;
  acc09_tot: string;
  acc10_tot: string;
  acc11_tot: string;
  acc12_tot: string;
  accyear_tot: string;

  // 차이
  gap01_tot: string;
  gap02_tot: string;
  gap03_tot: string;
  gap04_tot: string;
  gap05_tot: string;
  gap06_tot: string;
  gap07_tot: string;
  gap08_tot: string;
  gap09_tot: string;
  gap10_tot: string;
  gap11_tot: string;
  gap12_tot: string;

  // 예측건수
  predict01_tot: string;
  predict02_tot: string;
  predict03_tot: string;
  predict04_tot: string;
  predict05_tot: string;
  predict06_tot: string;
  predict07_tot: string;
  predict08_tot: string;
  predict09_tot: string;
  predict10_tot: string;
  predict11_tot: string;
  predict12_tot: string;
}

/**
 * 컨트롤러
 * @window w_tb_e411w_06
 * @category 고장예방보전관리
 */
export class BreakMonthForecast extends PageComponent<PageProps, BreakMonthForecastState> implements PageToolEvents {
  infinity?: InfinityRetrieve;

  grid: React.RefObject<GridLayout> = React.createRef();

  constructor(props: any, context: any) {
    super(props, context);
    this.props.onMount && this.props.onMount(this);

    this.state = props.state || {
      // 조회
      year: Today.year(),

      // 리스트
      breakMonthList: [],

      // 합계
      // 고장
      cnt01_tot: '0',
      cnt02_tot: '0',
      cnt03_tot: '0',
      cnt04_tot: '0',
      cnt05_tot: '0',
      cnt06_tot: '0',
      cnt07_tot: '0',
      cnt08_tot: '0',
      cnt09_tot: '0',
      cnt10_tot: '0',
      cnt11_tot: '0',
      cnt12_tot: '0',

      // 예측정확도
      acc01_tot: '0',
      acc02_tot: '0',
      acc03_tot: '0',
      acc04_tot: '0',
      acc05_tot: '0',
      acc06_tot: '0',
      acc07_tot: '0',
      acc08_tot: '0',
      acc09_tot: '0',
      acc10_tot: '0',
      acc11_tot: '0',
      acc12_tot: '0',
      accyear_tot: '0',

      // 차이
      gap01_tot: '0',
      gap02_tot: '0',
      gap03_tot: '0',
      gap04_tot: '0',
      gap05_tot: '0',
      gap06_tot: '0',
      gap07_tot: '0',
      gap08_tot: '0',
      gap09_tot: '0',
      gap10_tot: '0',
      gap11_tot: '0',
      gap12_tot: '0',

      // 예측
      predict01_tot: '0',
      predict02_tot: '0',
      predict03_tot: '0',
      predict04_tot: '0',
      predict05_tot: '0',
      predict06_tot: '0',
      predict07_tot: '0',
      predict08_tot: '0',
      predict09_tot: '0',
      predict10_tot: '0',
      predict11_tot: '0',
      predict12_tot: '0',
    };
  }

  @action
  async onFirstOpenEvent() {
    await this.onRetrieveEvent();
  }

  @action
  async onRetrieveEvent() {
    const { actionStore: api } = this.props;

    this.infinity = new InfinityRetrieve(
      {
        year: this.state.year,
      },
      (params) => api.retrieve(params),
      (items, next) => {
        this.setState({
          breakMonthList: [...this.state.breakMonthList, ...items.map((item) => new BreakMonthForecastModel(item))],
        }, next);
      },
      async () => {
        await this.SS({
          breakMonthList: [],
        });
        await this.infinity?.retrieve();
        this.grid.current?.setFocus(0);
      },
    );

    // 초기화
    await this.SS({
      breakMonthList: [],
    });

    // 조회
    await this.infinity?.retrieve();
    this.grid.current?.setFocus(0);

    // 합계, 소숫점
    await this.SS({
      // 고장
      cnt01_tot: this.infinity?.box?.cnt01_tot || '0',
      cnt02_tot: this.infinity?.box?.cnt02_tot || '0',
      cnt03_tot: this.infinity?.box?.cnt03_tot || '0',
      cnt04_tot: this.infinity?.box?.cnt04_tot || '0',
      cnt05_tot: this.infinity?.box?.cnt05_tot || '0',
      cnt06_tot: this.infinity?.box?.cnt06_tot || '0',
      cnt07_tot: this.infinity?.box?.cnt07_tot || '0',
      cnt08_tot: this.infinity?.box?.cnt08_tot || '0',
      cnt09_tot: this.infinity?.box?.cnt09_tot || '0',
      cnt10_tot: this.infinity?.box?.cnt10_tot || '0',
      cnt11_tot: this.infinity?.box?.cnt11_tot || '0',
      cnt12_tot: this.infinity?.box?.cnt12_tot || '0',
      // 고장예측율
      acc01_tot: this.infinity?.box?.acc01_tot || '0',
      acc02_tot: this.infinity?.box?.acc02_tot || '0',
      acc03_tot: this.infinity?.box?.acc03_tot || '0',
      acc04_tot: this.infinity?.box?.acc04_tot || '0',
      acc05_tot: this.infinity?.box?.acc05_tot || '0',
      acc06_tot: this.infinity?.box?.acc06_tot || '0',
      acc07_tot: this.infinity?.box?.acc07_tot || '0',
      acc08_tot: this.infinity?.box?.acc08_tot || '0',
      acc09_tot: this.infinity?.box?.acc09_tot || '0',
      acc10_tot: this.infinity?.box?.acc10_tot || '0',
      acc11_tot: this.infinity?.box?.acc11_tot || '0',
      acc12_tot: this.infinity?.box?.acc12_tot || '0',
      accyear_tot: this.infinity?.box?.accyear_tot || '0',
      // 차이
      gap01_tot: this.infinity?.box?.gap01_tot || '0',
      gap02_tot: this.infinity?.box?.gap02_tot || '0',
      gap03_tot: this.infinity?.box?.gap03_tot || '0',
      gap04_tot: this.infinity?.box?.gap04_tot || '0',
      gap05_tot: this.infinity?.box?.gap05_tot || '0',
      gap06_tot: this.infinity?.box?.gap06_tot || '0',
      gap07_tot: this.infinity?.box?.gap07_tot || '0',
      gap08_tot: this.infinity?.box?.gap08_tot || '0',
      gap09_tot: this.infinity?.box?.gap09_tot || '0',
      gap10_tot: this.infinity?.box?.gap10_tot || '0',
      gap11_tot: this.infinity?.box?.gap11_tot || '0',
      gap12_tot: this.infinity?.box?.gap12_tot || '0',
      // 예측
      predict01_tot: this.infinity?.box?.predict01_tot || '0',
      predict02_tot: this.infinity?.box?.predict02_tot || '0',
      predict03_tot: this.infinity?.box?.predict03_tot || '0',
      predict04_tot: this.infinity?.box?.predict04_tot || '0',
      predict05_tot: this.infinity?.box?.predict05_tot || '0',
      predict06_tot: this.infinity?.box?.predict06_tot || '0',
      predict07_tot: this.infinity?.box?.predict07_tot || '0',
      predict08_tot: this.infinity?.box?.predict08_tot || '0',
      predict09_tot: this.infinity?.box?.predict09_tot || '0',
      predict10_tot: this.infinity?.box?.predict10_tot || '0',
      predict11_tot: this.infinity?.box?.predict11_tot || '0',
      predict12_tot: this.infinity?.box?.predict12_tot || '0',
    });
  }

  @action
  async onPrintEvent() {
    const { actionStore: api } = this.props;
    if (!ConfirmWarning.assert(this.state.breakMonthList.length, '오류', '출력할 내역이 없습니다.')) {
      return;
    }
    await api.printWithElmanManager({
      year: this.state.year,
    });
  }

  @action
  async onExcelEvent() {
    const { actionStore: api } = this.props;
    if (this.state.breakMonthList.length < 1) {
      ConfirmWarning.show('오류', '엑셀전환할 내역이 없습니다.');
      return;
    }

    await api.excel({
      year: this.state.year,
    });
  }

  render() {
    return (
      <BreakMonthForecastTemplate scope={this} />
    );
  }
}
